import type { FC } from "react";

import { translate } from "app/filters/i18nFilter";
import { type InclusionOption, inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

import { StyledRadioButton, StyledRadioContainer, StyledRadioSelection } from "./styles";

interface IInclusionTechnologyRadioButtonsProps {
    isExcludeAvailable: boolean;
    selectedInclusion: InclusionOption;
    onSelect(inclusion: InclusionOption): void;
}

const InclusionTechnologyRadioButtons: FC<IInclusionTechnologyRadioButtonsProps> = ({
    isExcludeAvailable,
    selectedInclusion,
    onSelect,
}) => {
    return (
        <StyledRadioSelection>
            <StyledRadioContainer>
                <StyledRadioButton
                    itemSelected={selectedInclusion === inclusionOptionMap.includeOnly}
                    onClick={() => onSelect(inclusionOptionMap.includeOnly)}
                    itemLabel={translate(`si.components.modal.radio.${inclusionOptionMap.includeOnly}`)}
                />
            </StyledRadioContainer>
            <StyledRadioContainer>
                <StyledRadioButton
                    itemDisabled={!isExcludeAvailable}
                    itemSelected={selectedInclusion === inclusionOptionMap.excludeOnly}
                    onClick={() => onSelect(inclusionOptionMap.excludeOnly)}
                    itemLabel={translate(`si.components.modal.radio.${inclusionOptionMap.excludeOnly}`)}
                />
            </StyledRadioContainer>
        </StyledRadioSelection>
    );
};

export default InclusionTechnologyRadioButtons;
